module.exports = __webpack_public_path__ + "static/media/site_org_structure.e2bf20e9.png";